import { useEffect, useRef } from "react";
import styles from "./styles.module.scss";

function VideoComponent({ track, local = false }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (track && videoRef.current) {
      track.attach(videoRef.current);
    }

    return () => {
      if (track && videoRef.current) {
        track.detach(videoRef.current);
      }
    };
  }, [track]);

  return (
      <video
        ref={videoRef}
        /* id={track.sid} */
        autoPlay
        playsInline
        muted={local}
        className={styles.video}
      />
  );
}

export default VideoComponent;
